var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"append-to-body":"","title":"代码结构","close-on-click-modal":false,"visible":_vm.show,"width":"60%"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('monaco-editor',{attrs:{"disabled":""},model:{value:(_vm.contain.json),callback:function ($$v) {_vm.$set(_vm.contain, "json", $$v)},expression:"contain.json"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }